export default "__VITE_ASSET__66cdad7a__"